import { ICONS } from "../../../../../components/common/cards/product-card/utils/constants.js";
export const productCardFliMobileConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , link ={
        href: ''
    } , image ={
        src: ''
    } , price , isDeal =false , subtitle , descriptions =[] , isBlackfriday =false  } = data;
    return {
        ...data,
        config: {
            isBlackfriday,
            soldOut: props.soldOut,
            deal: isDeal,
            icon: true,
            iconName: ICONS.ICO_PLANE,
            literals: {
                fromCaption: price?.from
            }
        },
        image,
        link,
        price: {
            value: price?.value
        },
        title,
        subtitle,
        descriptions
    };
};

//# sourceMappingURL=converter.js.map